import { useContext } from 'react';
import { AmplitudeContext, AmplitudeContextValues } from '@/context/AmplitudeContext';

const useAmplitudeContext = (): AmplitudeContextValues => {
    const context = useContext<AmplitudeContextValues>(AmplitudeContext);

    if (context === undefined) {
        throw new Error(
            'useAmplitudeContext must be used within a AmplitudeContextProvider'
        );
    }

    return context;
};

export default useAmplitudeContext;
